import React from "react";
import { Tabs as AntdTabs, Flex, Skeleton, type TabsProps } from "antd";
import styles from "./Tabs.module.css";

interface CustomTabProps extends TabsProps {
  className?: string;
  tabBarGutter?: number;
  activeColor?: string;
  loading?: boolean;
  skeletonCount?: number;
}

const TabsLoader = ({ count = 5 }: { count: number }) => {
  return (
    <Flex gap={8} style={{ marginBottom: 24 }}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton.Button
          key={index}
          active
          style={{ height: "40px", width: "120px" }}
        />
      ))}
    </Flex>
  );
};

const Tabs: React.FC<CustomTabProps> = ({
  className,
  loading = false,
  skeletonCount = 5,
  ...props
}) => {

  if (loading) {
    return <TabsLoader count={skeletonCount} />;
  }

  return (
    <AntdTabs
      {...props}
      className={`${styles.customTab} ${className || ""}`}
      tabBarGutter={0}
    />
  );
};

export default Tabs;
